import { Button, Image } from "antd";
import React from "react";

const Poster = () => {
  return (
    <>
      <div
        className="colorfulcontainer"
        style={{
          //   borderBottom: "1px solid red",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          overflow: "auto",
          // padding: 2,
          //   height: "100vh",
          //   width: "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "#000",
            // height: 80,
            maxWidth: 800,
            width: "100%",
            // border: "1px solid red",

            paddingTop: 20,
            paddingBottom: 10,
          }}
        >
          <Button
            style={{ borderRadius: "0.5rem", fontWeight: "bold" }}
            type="default"
            target="_blank"
            href="https://www.facebook.com/nehemiahsolutionsph"
          >
            BOOK A DEMO NOW!
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "#fff",
            flexDirection: "column",
            maxWidth: 800,
            padding: 20,
            // border: "1px solid red",

            // borderBottom: "1px solid red",
          }}
        >
          <Image
            width={"auto"}
            // height={collapsed ? 45 : 100}
            src={require("./../../assets/poster1.jpg")}
            placeholder={"poster1"}
            preview={false}
            style={{ boxShadow: "1px 2px 9px #AEAEAE" }}
          />
          <Image
            width={"auto"}
            // height={collapsed ? 45 : 100}
            src={require("./../../assets/poster2.jpg")}
            placeholder={"poster2"}
            preview={false}
            style={{
              marginTop: 20,
              marginBottom: 20,
              boxShadow: "1px 2px 9px #AEAEAE",
            }}
          />
          <Image
            width={"auto"}
            // height={collapsed ? 45 : 100}
            src={require("./../../assets/poster3.jpg")}
            placeholder={"poster3"}
            preview={false}
            style={{ boxShadow: "1px 2px 9px #AEAEAE" }}
          />
        </div>
      </div>
    </>
  );
};

export default Poster;
